import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Badge, Heading, LinkButton, ModuleContainer, RichText } from "../element";
export var TextContentBlock = function(param) {
    var _content = param.content, badge = _content.badge, heading = _content.heading, content = _content.content, link = _content.link, rules = param.rules;
    var ref = rules || {}, badgeRules = ref.badge, columns = ref.columns, tmp = ref.heading, headingStyle = tmp === void 0 ? {} : tmp, isContainerMultiColumn = ref.isContainerMultiColumn, isSecondColumn = ref.isSecondColumn, textStyle = ref.textStyle, verticalSpacing = ref.verticalSpacing;
    var style = (textStyle || {}).style;
    return /*#__PURE__*/ _jsxs(ModuleContainer, {
        rules: {
            isSecondColumn: isSecondColumn,
            verticalSpacing: verticalSpacing
        },
        children: [
            /*#__PURE__*/ _jsx(Badge, {
                content: badge,
                rules: {
                    badge: badgeRules
                }
            }),
            /*#__PURE__*/ _jsx(Heading, {
                content: heading,
                rules: _object_spread({
                    textStyle: {
                        style: style
                    }
                }, headingStyle)
            }),
            content && /*#__PURE__*/ _jsx(RichText, {
                content: content,
                rules: {
                    columns: columns,
                    textStyle: {
                        style: style
                    }
                }
            }),
            /*#__PURE__*/ _jsx(LinkButton, {
                content: link,
                rules: {
                    variant: "secondary",
                    size: "small",
                    horizontalSpacing: {
                        isCentered: !isContainerMultiColumn
                    }
                }
            })
        ]
    });
};
